import { Pipe, PipeTransform, inject } from '@angular/core';
import { TAInput, TimePastService } from '@commons/time-past';
import { Observable } from 'rxjs';

@Pipe({ standalone: true, name: 'timePast' })
export class TimePastPipe implements PipeTransform {
  readonly #timePastService = inject(TimePastService);

  transform<T extends TAInput>(value: T): Observable<string | undefined> {
    return this.#timePastService.timePast(value);
  }
}
